export const deDE = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Lassie",
  legalName: "Lassie AB Zweigniederlassung",
  url: "https://de.lassie.co",
  logo: "https://de.lassie.co/images/logo-with-name.svg",
  description:
    "Die erste präventive Haustierversicherung für Hunde und Katzen, die wie deine Krankenversicherung funktioniert. Bis zu 100 % Kostenübernahme und 140 € jährlich für Vorsorge",
  email: "kontakt@lassie.de",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Münzstrasse 21",
    postalCode: "10178",
    addressLocality: "Berlin",
    addressCountry: "DE",
  },
  sameAs: [
    "https://www.facebook.com/Lassie.Deutschland/",
    "https://www.instagram.com/lassie_de/",
    "https://www.youtube.com/@lassie_co",
    "https://www.linkedin.com/company/lassieco/",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Versicherungen",
    itemListElement: [
      {
        "@type": "OfferCatalog",
        name: "Hundeversicherungen",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Hundekrankenversicherung Mini",
              description:
                "Basisschutz für Hunde mit Deckung für Krankheiten und Unfälle. Deckt Operationen, medizinische Behandlungen und Notfallversorgung ab.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Hundekrankenversicherung Midi",
              description:
                "Umfassender Schutz für Hunde mit erweiterter Deckung. Beinhaltet Operationen, Behandlungen, Medikamente, Rehabilitation, Futter und bis zu 100€ Vorsorgebudget pro Jahr.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Hundekrankenversicherung Maxi",
              description:
                "Premiumschutz für Hunde mit maximaler Deckung für alle medizinischen Behandlungen. Unbegrenzte Deckung für Operationen und Heilbehandlungen sowie bis zu 140€ Vorsorgebudget pro Jahr.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Hunde OP-Versicherung",
              description:
                "OP-Versicherung für Hunde mit bis zu 100% Kostenübernahme und unbegrenzter OP-Deckung. Schützt vor hohen Operationskosten und deckt Vor- und Nachbehandlungen ab.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=dog",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Hundehaftpflichtversicherung",
              description:
                "Hundehaftpflichtversicherung mit bis zu 10 Millionen Euro Deckung je Versicherungsfall. Schützt vor Kosten bei Personen-, Sach- und Vermögensschäden, die durch den Hund verursacht werden.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=dog",
              },
            ],
          },
        ],
      },
      {
        "@type": "OfferCatalog",
        name: "Katzenversicherungen",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Katzenkrankenversicherung Mini",
              description:
                "Basisschutz für Katzen mit Deckung für Krankheiten und Unfälle. Deckt Operationen, medizinische Behandlungen und Notfallversorgung ab.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Katzenkrankenversicherung Midi",
              description:
                "Umfassender Schutz für Katzen mit erweiterter Deckung. Beinhaltet Operationen, Behandlungen, Medikamente, Rehabilitation, Futter und bis zu 100€ Vorsorgebudget pro Jahr.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Katzenkrankenversicherung Maxi",
              description:
                "Premiumschutz für Katzen mit maximaler Deckung für alle medizinischen Behandlungen. Unbegrenzte Deckung für Operationen und bis zu 140€ Vorsorgebudget pro Jahr.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=cat",
              },
            ],
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Katzen OP-Versicherung",
              description:
                "OP-Versicherung für Katzen mit bis zu 100% Kostenübernahme und unbegrenzter OP-Deckung. Schützt vor hohen Operationskosten und deckt Vor- und Nachbehandlungen ab.",
            },
            potentialAction: [
              {
                "@type": "BuyAction",
                target: "https://de.lassie.co/signup/?species=cat",
              },
            ],
          },
        ],
      },
    ],
  },
};
